import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * H3 heading component
 * Block-level heading component for subsection titles
 */
const H3 = ({ children, ...props }) => {
  return (
    <Typography variant="h3" component="h3" {...props}>
      {children}
    </Typography>
  );
};

H3.propTypes = {
  children: PropTypes.node.isRequired,
};

export default H3;
